enum AuthChallenge {
  NewPasswordRequired = 'NEW_PASSWORD_REQUIRED',
}

export default AuthChallenge;
